import { render, staticRenderFns } from "./ApplicationCard.vue?vue&type=template&id=510996e6&lang=pug&"
import script from "./ApplicationCard.vue?vue&type=script&lang=js&"
export * from "./ApplicationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports